/* global Session */
import React, { forwardRef, useRef, useImperativeHandle, useState } from 'react';
import moment from 'moment';
import styled from 'styled-components';
import BaseModal from '../';

const Body = styled.div`
    padding: 15px;
`;

const MODAL_VIEWS = {
    ACTIONS: 'actions',
    INFO: 'info',
    ERROR: 'error'
};

const ReportTypeModal = (props, ref) => {
    const baseModalRef = useRef(null);
    const [reportData, setReportData] = useState({});
    const [template, setTemplate] = useState(MODAL_VIEWS.ACTIONS);
    const [submitTicketUrl, setSubmitTicketUrl] = useState('');

    useImperativeHandle(ref, () => ({
        openModal(data = {}) {
            setTemplate(data?.status === 500 ? MODAL_VIEWS.ERROR : MODAL_VIEWS.ACTIONS);
            setReportData(data);
            baseModalRef.current.openModal();
        }
    }));

    Session.retrieveSystemProperty('CAT_SUPPORT_URL', 'rckms').then((data) => {
        setSubmitTicketUrl(data);
    });

    return (
        <BaseModal
            {...props}
            title={reportData.title}
            ref={baseModalRef}
            height={'auto'}
            noScroll={true}
            footer={false}
        >
            {template === MODAL_VIEWS.ERROR && (
                <>
                    <Body>
                        <strong>An unexpected error has occurred:</strong> unable to access reports storage. Please try
                        your request again later, or{' '}
                        <a href={submitTicketUrl} target="_blank" rel="noopener noreferrer">
                            submit a ticket
                        </a>{' '}
                        if this issue persists.
                    </Body>
                </>
            )}
            {template === MODAL_VIEWS.ACTIONS && (
                <>
                    <Body>
                        {reportData?.fileRef ? (
                            <>
                                <p>
                                    This report was last generated{' '}
                                    <strong>{moment(reportData.created).fromNow()}</strong>.
                                </p>
                                <p>Would you like to download the latest report or generate a new one?</p>
                            </>
                        ) : (
                            <p>
                                No previously generated report found. Please click the button below to generate this
                                report.
                            </p>
                        )}
                    </Body>
                    {reportData.actions && (
                        <div className="modal-footer">
                            {reportData?.fileRef && (
                                <button
                                    className="btn btn-primary"
                                    onClick={() => {
                                        reportData.actions?.downloadLatest(reportData.fileRef);
                                        baseModalRef.current.closeModal();
                                    }}
                                >
                                    Latest Report
                                </button>
                            )}
                            <button
                                className="btn btn-secondary"
                                onClick={async () => {
                                    try {
                                        if (!reportData.actions?.generateReport) {
                                            throw Error('generateReport function not provided to modal controller.');
                                        }
                                        await reportData.actions?.generateReport();
                                        setTemplate(MODAL_VIEWS.INFO);
                                    } catch (err) {
                                        baseModalRef.current.closeModal();
                                    }
                                }}
                            >
                                Generate Report
                            </button>
                        </div>
                    )}
                </>
            )}
            {template === MODAL_VIEWS.INFO && (
                <>
                    <Body>
                        <p>
                            The report is being generated but will take some time. You will receive a notification when
                            it is ready for download.
                        </p>
                    </Body>
                    <div className="modal-footer">
                        <button
                            className="btn btn-primary"
                            onClick={() => {
                                baseModalRef.current.closeModal();
                            }}
                        >
                            Close
                        </button>
                    </div>
                </>
            )}
        </BaseModal>
    );
};

export default forwardRef(ReportTypeModal);
